import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  current: number;
  total: number;
  message?: string;
  iconUrl?: string; // optional custom icon (or thumbnail)
};

export function UploadProgressToast({
  current,
  total,
  message = 'dashboard.defaultProgressDescription',
  iconUrl
}: Props) {
  const { t } = useTranslation();
  if (message !== '') {
    message = t(message);
  }
  return (
    <div className="relative flex w-full items-start gap-3 rounded-xl bg-[#F3FBEA] px-4 py-3">
      {/* LEFT ICON */}
      <div className="mt-0.5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-[#E4F7C8]">
        {iconUrl ? (
          <img
            src={iconUrl}
            alt="upload icon"
            className="h-full w-full object-cover"
          />
        ) : (
          <span className="h-4 w-4 rounded-full bg-[#6BB74B]" />
        )}
      </div>

      {/* TEXT */}
      <div className="flex flex-col gap-1 pr-6">
        <div className="text-sm font-bold leading-5 text-[#1E1E1E]">
          {t('dashboard.uploadProgressPhotos', { current, total })}
        </div>
        <div className="max-w-[360px] text-xs font-medium leading-4 text-[#4F7A33]">
          {message}
        </div>
      </div>
    </div>
  );
}
